import {
    Baby,
    BookOpen,
    Hammer,
    LaptopMinimalCheck,
    Sprout,
    WandSparkles,
    type LucideIcon,
} from "lucide-react";
import { Category } from "types/category";

export interface CategoryStyle {
    Icon: LucideIcon;
    boxClass: string;
    iconClass: string;
}

const DEFAULT_STYLE: CategoryStyle = {
    Icon: WandSparkles,
    boxClass: "bg-slate-100",
    iconClass: "text-slate-600",
};

const CATEGORY_STYLES: Record<string, CategoryStyle> = {
    [Category.HOUSEKEEPING.toString()]: {
        Icon: WandSparkles,
        boxClass: "bg-violet-100",
        iconClass: "text-violet-600",
    },
    [Category.GARDENING.toString()]: {
        Icon: Sprout,
        boxClass: "bg-emerald-100",
        iconClass: "text-emerald-600",
    },
    [Category.HANDIWORK.toString()]: {
        Icon: Hammer,
        boxClass: "bg-amber-100",
        iconClass: "text-amber-600",
    },
    [Category.ASSISTANCE.toString()]: {
        Icon: LaptopMinimalCheck,
        boxClass: "bg-pink-100",
        iconClass: "text-pink-600",
    },
    [Category.CHILDCARE.toString()]: {
        Icon: Baby,
        boxClass: "bg-pink-100",
        iconClass: "text-pink-600",
    },
    [Category.PRIVATE_TUTORING.toString()]: {
        Icon: BookOpen,
        boxClass: "bg-indigo-100",
        iconClass: "text-indigo-600",
    },
};

export function getCategoryStyle(category: string): CategoryStyle {
    return CATEGORY_STYLES[category] ?? DEFAULT_STYLE;
}
